import {
  ReportDone5SAuditState,
  ReportDone5SAuditActions,
  ReportDone5SAuditActionTypes,
} from '../../types/reportDone5SAudit';

const initialState: ReportDone5SAuditState = {
  data: null,
  loading: false,
  error: null,
};

export const reportDone5SAudit = (state = initialState, action: ReportDone5SAuditActions): ReportDone5SAuditState => {
  switch (action.type) {
    case ReportDone5SAuditActionTypes.LOAD_REQUEST:
      return { ...state, loading: true, error: null };
    case ReportDone5SAuditActionTypes.LOAD_SUCCESS:
      return { data: action.payload.data, loading: false, error: null };
    case ReportDone5SAuditActionTypes.LOAD_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
};
